import { errors, messages } from '../messages.constants';
import { getRandomNumber } from '~/utils';
import { triggerApiErrorAnalytics } from '~/analytics/analytics.listener';

const { SOMETHING_WENT_WRONG_ERROR, STILL_CANT_LOAD_THE_PAGE_ERROR } = errors;

const actionPrefix = (actionType) => `Messages/${actionType}`;

export const RESET_ERROR_MESSAGE_WITH = actionPrefix`RESET_ERROR_MESSAGE_WITH`;
export const resetErrorMessagesWith = (errorMessages) => ({
  type: RESET_ERROR_MESSAGE_WITH,
  // TODO Remade this without using random number as id
  payload: errorMessages.map((message) => ({ ...message, id: getRandomNumber(0, 1000) })),
});

export const TRY_AGAIN_CLICKED = actionPrefix`TRY_AGAIN_CLICKED`;
export const tryAgainClicked = (param) => ({
  type: TRY_AGAIN_CLICKED,
  payload: param,
});

export const pushServerErrorMessage = (url, status) => (dispatch, getState) => {
  const {
    messages: {
      app: { tryAgainClicked: tryAgain },
    },
    appointment: {
      draft: {
        shop: { id: shopId },
      },
    },
  } = getState();
  const messageType = tryAgain ? STILL_CANT_LOAD_THE_PAGE_ERROR : SOMETHING_WENT_WRONG_ERROR;
  triggerApiErrorAnalytics(shopId, messages.errors[messageType].title);
  dispatch(
    resetErrorMessagesWith([
      {
        type: messageType,
        description: messages.errors[messageType].description,
        url,
        status,
      },
    ]),
  );
};

export const REMOVE_SERVER_ERROR_MESSAGE = actionPrefix`REMOVE_SERVER_ERROR_MESSAGE`;
export const removeServerErrorMessage = (url) => ({
  type: REMOVE_SERVER_ERROR_MESSAGE,
  payload: url,
});

export const CLEAR_ERROR_MESSAGES = actionPrefix`CLEAR_ERROR_MESSAGES`;
export const clearErrorMessages = () => ({
  type: CLEAR_ERROR_MESSAGES,
});

export const CLEAR_ONLY_ERROR_MESSAGES = actionPrefix`CLEAR_ONLY_ERROR_MESSAGES`;
export const clearOnlyErrorMessages = () => ({
  type: CLEAR_ONLY_ERROR_MESSAGES,
});

export const REMOVE_SINGLE_ERROR_MESSAGE = actionPrefix`REMOVE_SINGLE_ERROR_MESSAGE`;
export const removeSingleErrorMessage = (type) => ({
  type: REMOVE_SINGLE_ERROR_MESSAGE,
  payload: type,
});

export const PUSH_SECTION_ERROR = actionPrefix`PUSH_SECTION_ERROR`;
export const pushSectionError = (sectionError) => ({
  type: PUSH_SECTION_ERROR,
  payload: sectionError,
});

export const CLEAR_SECTION_ERRORS = actionPrefix`CLEAR_SECTION_ERRORS`;
export const clearSectionErrors = (questionId) => ({
  type: CLEAR_SECTION_ERRORS,
  payload: questionId,
});

export const CLEAR_SECTION_ERRORS_AND_ERROR_MESSAGES = actionPrefix`CLEAR_SECTION_ERRORS_AND_ERROR_MESSAGES`;
export const clearSectionErrorsAndErrorMessages = (questionId) => ({
  type: CLEAR_SECTION_ERRORS_AND_ERROR_MESSAGES,
  payload: questionId,
});

export const PUSH_SECTION_ERROR_TO_ERROR_MESSAGE = actionPrefix`PUSH_SECTION_ERROR_TO_ERROR_MESSAGE`;
export const pushSectionErrorToErrorMessage = () => ({
  type: PUSH_SECTION_ERROR_TO_ERROR_MESSAGE,
});
